import React, {useState, useEffect} from 'react';
import {BadgeProp, BadgesProps} from "./Badges.props";
import {Box, Tooltip, Typography} from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import BadgeSlider from '../BadgeSlider/BadgeSlider';
import './Badges.css'
import {TOOLTIP_MESSAGES} from "../../constants/constants";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import AchievementsPopup from "../AchievementsPopup/AchievementsPopup";

const Badges: React.FC<BadgesProps> = ({data = {badges: []}, onOpenAchievementChange}) => {
  const [badgeList, setBadgeList] = useState<BadgeProp[]>([]);
  const [openAchievementLevel, setOpenAchievementLevel] = React.useState(false);
  const {badges} = data;

  useEffect(() => {
    if (!badges || badges.length === 0) {
      return;
    }

    const unlockedBadges = badges.filter(item => item.status === 'unlocked')
    setBadgeList(unlockedBadges)
  }, [badges]);

  const handleClickOpen = () => {
    setOpenAchievementLevel(true);
    onOpenAchievementChange?.(true);
  };

  return (
    <>
      <div className={'badge-container'}>
        <Box width={'100%'} mb={'37px'}>
          <Box width={'100%'} display="flex" justifyContent="space-between">
            <Typography
              sx={{fontFamily: 'Righteous', fontSize: 24, fontWeight: 400, color: '#193051'}}>Achievements</Typography>
            <Typography gap={1} sx={{display: 'flex'}}>
              <Tooltip
                title={TOOLTIP_MESSAGES.PROFILE_BADGE}
                placement="top-start"
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      fontSize: '13px',
                      [`&.MuiTooltip-tooltipPlacementTop`]: {
                        maxWidth: 'fit-content',
                      },
                    },
                  },
                }}
              >
                <InfoOutlinedIcon sx={{position: "relative", top: "4px", cursor: "pointer"}} fontSize={"medium"}
                                  htmlColor={"#193051"}/>
              </Tooltip>
              <Tooltip
                title={''}
                placement="top-start"
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      fontSize: '13px',
                      [`&.MuiTooltip-tooltipPlacementTop`]: {
                        maxWidth: 'fit-content',
                      },
                    },
                  },
                }}
              >
                <OpenInNewIcon
                  data-testid={'open-icon'}
                  onClick={() => handleClickOpen()}
                  sx={{position: "relative", top: "4px", cursor: "pointer"}} fontSize={"medium"}
                  htmlColor={"#193051"}/>
              </Tooltip>
            </Typography>
          </Box>
          <Box width={'100%'} display="flex" justifyContent="space-between">
            <Typography className='badge-content-text'>
              {badgeList?.length ? (
                <>
                  Congratulations! You’ve
                  unlocked {badgeList.length} {badgeList.length > 1 ? 'achievements' : 'achievement'} on your journey.
                </>
              ) : (
                <>You haven't unlocked any achievements yet but every step brings you closer!</>
              )}
            </Typography>
          </Box>
        </Box>
        <div className={'badge-content'}>
          <BadgeSlider badgeList={badgeList}/>
        </div>
      </div>
      <AchievementsPopup
        setOpen={(isOpen: boolean) => {
          setOpenAchievementLevel(isOpen);
          onOpenAchievementChange?.(isOpen);
        }}
        open={openAchievementLevel}
        title={'Achievement List'}
        subTitle={'See what you’ve unlocked and what you can aim for next.'}
        badgeList={badges}
      />
    </>
  );
};

export default Badges;
